import { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-primary text-foreground flex flex-col font-sans">
      {/* Header */}
      <header className="bg-primary/95 backdrop-blur-sm border-b border-white/10 px-4 py-4 sticky top-0 z-50">
        <div className="flex items-center justify-center">
          <h1 className="font-serif text-foreground text-2xl tracking-wide uppercase">
            Chateaushi
          </h1>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 pb-safe">
        {children}
      </main>
    </div>
  );
}
